// extracted by mini-css-extract-plugin
export default {"root":"ReviewSlider_root__nLekp","slider":"ReviewSlider_slider__NOsUA","slider_no_controls":"ReviewSlider_slider_no_controls__ye3ZQ","item":"ReviewSlider_item__NJN8F"};